import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ForecastCard from "@/components/feature/ForecastCard";
import { forecasts } from "@/mocks/forecast";

export default function TodayForecast() {
  const today = forecasts.slice(1, 4);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="今日预警"
          title="正在发酵的预告前瞻"
          description="这些线索尚未引爆，但已经出现明显的偏移信号。点进去可以看到完整的信号清单与时间线。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {today.map((item, index) => (
            <Reveal key={item.id} delay={index * 90}>
              <ForecastCard item={item} />
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 flex justify-center">
            <Link
              to="/forecast"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看全部前瞻
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}